import {GameModel} from "./game.model";
import {ProviderModel, PublisherModel} from "./provider.model";
import {Game, Games} from "./game.class";
import {ConfigService} from "../services/config.service";
import {GameService} from "../services/game.service";
import {inject} from "@angular/core";

export class Publisher implements ProviderModel {

  constructor(public raw: PublisherModel) { }

  // static get(id: string): Publisher
  // {
  //
  // }
  get routerLink(): string {
    return this.raw.slug
  }

  get name(): string {
    //name from Rival: this.raw.name
    //display name:
    return this.raw.display_name
  }


  get imagePath(): string {
    return this.raw.logo
  }


  get description(): string | undefined {
    return this.raw.description
  }


  get enabled(): boolean | undefined {
    return this.raw.enabled
  }

  get weight(): number {
    return this.raw.weight
  }

  get gameList(): Game[] {
    return this.raw.gameList ? this.raw.gameList : []
  }

  // Assign games to this publisher
  addGames(games: Game[]): void {
    this.raw.gameList = games.filter(game=>game.publisher.toLowerCase().includes(this.raw.display_name.toLowerCase()));
  }

  toString(): string {
    return this.name
  }

}

export class Publishers {

  #publishers: Publisher[] = [];

  constructor(public publishers: PublisherModel[]) {
    this.#publishers = publishers.map(p => new Publisher({...p}))
  }

  addGamesToPublishers(games: Game[]) {
    this.#publishers.forEach(publisher => publisher.addGames(games));
    return this;
  }

  sortByWeight(): Publisher[] {
    return [...this.#publishers].sort((a, b) => a.weight - b.weight);
  }

  get all(): Publisher[] {
    return this.#publishers;
  }


  get length(){
    return this.#publishers.length
  }


}
